export const GET_CURRENT_ASSET_CATEGORY = "GET_CURRENT_ASSET_CATEGORY";
export const RESET_CURRENT_ASSET_CATEGORY = "RESET_CURRENT_ASSET_CATEGORY";
export const SET_CURRENT_ASSET_CATEGORY_REQUEST_STATUS = "SET_CURRENT_ASSET_CATEGORY_REQUEST_STATUS";
